module.exports = __webpack_public_path__ + "static/media/kyte.3abeb64f.svg";